import React from 'react';

import { ReactComponent as DropdownArrowIcon } from '../../../../../assets/svgs/icon-dropdown-arrow.svg';
import { ReactComponent as EventCreateIcon } from '../../../../../assets/svgs/event-create.svg';
import { getButtonClassName } from './helpers';
import { DROPDOWN_ARROW_ICON_WIDTH, TestID } from './constants';

export interface Props {
  isDisabled: boolean;
  onClick?: () => void;
  selectedDatetime?: Date;
}

const DatePickerCustomInput: React.FC<Props> = ({
  children,
  isDisabled,
  onClick,
  selectedDatetime,
}) => (
  <button
    aria-disabled={isDisabled}
    className={getButtonClassName({ isDisabled })}
    data-testid={TestID}
    disabled={isDisabled}
    onClick={onClick}
  >
    <EventCreateIcon />

    <p className="px-3 w-full text-left">{children}</p>

    <DropdownArrowIcon
      className="text-gray-400 fill-current stroke-current"
      width={DROPDOWN_ARROW_ICON_WIDTH}
    />
  </button>
);

export default DatePickerCustomInput;
